import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../App';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { authUser, authLoading } = useAppContext();
  const location = useLocation();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <Loader2 className="w-12 h-12 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!authUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;